import React, { useRef, useEffect } from 'react';
import { ArrowRight, PlayCircle } from 'lucide-react';
import { SITE } from '../data/siteConfig';

export const VideoSection = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }, []);

  if (!SITE.videoUrl) return null;
  return (
    <section className="py-16 md:py-24 bg-slate-900" data-testid="video-section">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-2 text-emerald-400 font-semibold mb-3">
            <PlayCircle className="h-5 w-5" />
            <span className="text-sm uppercase tracking-wide">VIREO en vidéo</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 max-w-2xl leading-tight">
            Découvrez nos chantiers de rénovation et de ravalement
          </h2>
          <p className="text-slate-300 text-lg mb-10 max-w-2xl">
            Intérieurs rénovés, façades ravalées, isolation et toiture : un aperçu concret de notre
            savoir-faire à Paris et en Île-de-France, de l’étude à la réalisation.
          </p>

          <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 bg-black">
            <video
              ref={videoRef}
              data-testid="vireo-video"
              controls
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              poster={SITE.videoPoster}
              className="w-full h-auto aspect-video"
            >
              <source src={SITE.videoUrl} type="video/mp4" />
              Votre navigateur ne prend pas en charge la lecture vidéo.
            </video>
          </div>

          <div className="mt-10">
            <a
              href="/#contact"
              data-testid="video-cta"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-700 hover:to-cyan-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all hover:gap-3 shadow-xl"
            >
              Demander votre étude de projet <ArrowRight className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
